export default "__VITE_ASSET__C9HDg0d___"